/**
 *
 * Hero Event Block
 *
 * Handling event timer
 */

jQuery(document).ready(function(){
    let days = parseInt(jQuery('.timerDays > .num').text());
    let hours = parseInt(jQuery('.timerHours > .num').text());
    let minutes = parseInt(jQuery('.timerMinutes > .num').text());
    let seconds = parseInt(jQuery('.timerSeconds > .num').text());
    
    setInterval(function(){
        seconds--;
        if(seconds === -1) {
            seconds = 59;
            jQuery('.timerSeconds > .num').text(seconds); 
            minutes--;
            if(minutes === -1) {
                minutes = 59;
                jQuery('.timerMinutes > .num').text(minutes);
                hours--;
                if(hours === -1){
                    hours = 23;
                    jQuery('.timerMinutes > .num').text(hours);
                    while(days) {
                        days--;
                    }
                }
                else {
                    jQuery('.timerHours > .num').text(hours);
                }
            }
            else {
                jQuery('.timerMinutes > .num').text(minutes);
            }
        }
        else {
            jQuery('.timerSeconds > .num').text(seconds);
        }
    }, 1000);

});